const SvgKonstrukcjaPlytowa60 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 60 60">
    <path fill="#373737" d="M20.5 28a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
    <path fill="#373737" fillRule="evenodd" d="M15 2v56h30V2zm2 54V4h26v52z" clipRule="evenodd" />
  </svg>;
export default SvgKonstrukcjaPlytowa60;